import script from "./NewsTeaserCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsTeaserCard.vue?vue&type=script&setup=true&lang=js"

import "./NewsTeaserCard.vue?vue&type=style&index=0&id=87011ff0&lang=scss"

const __exports__ = script;

export default __exports__